/** @jsx jsx */
import React from "react";
import { jsx, css } from "@emotion/core";
interface Props extends Omit<React.SVGProps<SVGSVGElement>, "css"> {
  weight?: "thin" | "normal";
}
export const IconCalendar = ({
  fill = "none",
  stroke = "currentColor",
  weight = "normal",
  ...props
}: Props) => (
  <svg
    viewBox="0 0 24 24"
    css={css`
      * {
        vector-effect: non-scaling-stroke;
      }
      overflow: visible;
      height: 24px;
    `}
    {...props}
  >
    <g
      fill={fill}
      stroke={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={weight === "normal" ? 1.5 : 1}
    >
      <path d="M2.25 3.75h19.5a1.5 1.5 0 011.5 1.5v16.5a1.5 1.5 0 01-1.5 1.5H2.25a1.5 1.5 0 01-1.5-1.5V5.25a1.5 1.5 0 011.5-1.5zM.75 9.75h22.5M6.75 6V.75M17.25 6V.75M5.625 13.5h0" />
      <path d="M5.625 13.5a.375.375 0 100 .75.375.375 0 000-.75h0M5.625 18.75h0M5.625 18.75a.375.375 0 100 .75.375.375 0 000-.75M12 13.5h0M12 13.5a.375.375 0 100 .75.375.375 0 000-.75h0M12 18.75h0M12 18.75a.375.375 0 100 .75.375.375 0 000-.75M18.375 13.5h0M18.375 13.5a.375.375 0 100 .75.375.375 0 000-.75h0M18.375 18.75h0M18.375 18.75a.375.375 0 100 .75.375.375 0 000-.75" />
    </g>
  </svg>
);
